import {useQuery} from '@tanstack/react-query'
import {agendaRecebimentoService} from '../services/AgendaRecebimentoService'
import {agendaRecebimentoKeys} from './query-keys'
import type {
  AgendaRecebimentoReceivingBookingSupplierResponse,
  AgendaRecebimentoReceivingBookingTransportResponse,
  Identificador,
} from '../types'

interface ParametrosAgendamentosQuery {
  codigoUsuario: Identificador | null;
  filial: Identificador;
  status: string;
}

export function useAgendamentosFornecedorQuery({codigoUsuario, filial, status}: ParametrosAgendamentosQuery) {
  return useQuery<AgendaRecebimentoReceivingBookingSupplierResponse[]>({
    queryKey: agendaRecebimentoKeys.agendamentos('fornecedor', codigoUsuario ?? '', filial, status),
    queryFn: async () => {
      if (codigoUsuario === null) return []

      const {data} = await agendaRecebimentoService.getSupplier(codigoUsuario, filial, status)
      return data
    },
    enabled: codigoUsuario !== null,
  })
}

export function useAgendamentosTransportadoraQuery({codigoUsuario, filial, status}: ParametrosAgendamentosQuery) {
  return useQuery<AgendaRecebimentoReceivingBookingTransportResponse[]>({
    queryKey: agendaRecebimentoKeys.agendamentos('transportadora', codigoUsuario ?? '', filial, status),
    queryFn: async () => {
      if (codigoUsuario === null) return []

      const {data} = await agendaRecebimentoService.getTransports(codigoUsuario, filial, status)
      return data
    },
    enabled: codigoUsuario !== null,
  })
}
